import style from './css/intro.module.css'
import SlideAnimatePage from './components/SlideAnimatePage'
import { Checkbox, Flex, Menu, Portal, MenuItem, MenuList, MenuButton, Spinner, } from '@chakra-ui/react'
import { useContext, useEffect, useRef } from 'react'
import { generatePath, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import RoutePath from './routes/RoutePathDefinition'
import { SiteContext, useSyncState } from './Root'
import { useCookies } from 'react-cookie'
import axios from 'axios'

const Intro =()=>{
  const refl = useRef(null)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const isPortraitMode = useContext(SiteContext)[1]

  const roleData =useSyncState(undefined)
  const tableData =useSyncState(undefined)

  const processingTable1Request =useSyncState(false)
  const processingTable2Request =useSyncState(false)
  const processingRequest =useSyncState(false)
  const processingLogin =useSyncState(false)

  const msgDlgState = useContext(SiteContext)[2]

  const currPageIdx =useSyncState(0)

  const host ='https://94hi.net'
  const cid ='c94bcbd84e69e881673aab21dcf8e65d'
  const [cookies, setCookie, removeCookie] = useCookies(['94hitoken-shaiya-achievement-1'])
  const ref_addr ='https://shaiya.94hi.net/event/reservation/#/preorder'

  const isLogin =useSyncState(false)
  const isCookiesValid =(tmp_cookie)=>{
    if (tmp_cookie ==='' || tmp_cookie ===undefined || tmp_cookie ===null || 
        tmp_cookie['token']==='' || tmp_cookie['token']===undefined || tmp_cookie['token']===null ||
        tmp_cookie['mid']==='' || tmp_cookie['mid']===undefined || tmp_cookie['mid']===null){
      return false
    }
    return true
  }

  const check_login_state =(tmp_cookie)=>{
    processingLogin[1](false)

    //check login status
    //require login action
    if (isCookiesValid(tmp_cookie)===false){
      isLogin[1](false)
    }else{
      isLogin[1](true)
    }
  }
  const messageHandler =(e)=>{
    if (e.data !==undefined && e.data[cid]!==undefined){
      var tmp_cookie ={token:e.data[cid].token, mid:e.data[cid].mid}
      setCookie('94hitoken-shaiya-achievement-1', tmp_cookie, {path: '/',})

      console.warn('106 - update cookie : '+JSON.stringify(tmp_cookie))
      check_login_state(tmp_cookie)
    }
  }
  useEffect(()=>{
    var tmp_cookie =cookies['94hitoken-shaiya-achievement-1']
    check_login_state(tmp_cookie)

    if (searchParams.has('token') && searchParams.has('mid')){
      var override_token =searchParams.get('token')
      var override_mid =searchParams.get('mid')
      console.warn('override token : '+override_token+', mid='+override_mid)

      var tmp_cookie ={token:override_token, mid:override_mid}
      setCookie('94hitoken-shaiya-achievement-1', tmp_cookie, {path: '/',})

      console.warn('117 - update cookie : '+JSON.stringify(tmp_cookie))
      check_login_state(tmp_cookie)
    }

    window.addEventListener('message', messageHandler, {passive: true})
    return (()=>{
      window.removeEventListener('message', messageHandler)
    })
  },[])

  useEffect(()=>{
    var tmp_cookie =cookies['94hitoken-shaiya-achievement-1']
    if (isCookiesValid(tmp_cookie)){
      check_role_data(tmp_cookie)
    }else{
      roleData[1](undefined)
      tableData[1](undefined)
      currPageIdx[1](0)
    }
  },[cookies])

  var check_total_rank =(tmp_cookie)=>{
    if (processingTable1Request[2].current ===true || processingLogin[2].current ===true){
      return
    }

    tableData[1]([])
    currPageIdx[1](0)
    processingTable1Request[1](true)
    axios.get('https://1gg0c40d3e.execute-api.ap-northeast-1.amazonaws.com/Prod/totalKillTop?token='+tmp_cookie.token, ).then((res)=>{
      if (res.status ===200 && res.data.status ==='success'){

        tableData[1](res.data.data)
      }else{
        var msg =res.status
        if (res.data !==undefined && res.data.msg !==undefined){
          msg =res.data.msg
        }

        msgDlgState[2].current.title ='Error'
        msgDlgState[2].current.context =msg
        msgDlgState[2].current.showCancelBtn =false
        msgDlgState[2].current.onConfirm =()=>{
          msgDlgState[2].current.disclosure.onClose()
        }

        msgDlgState[2].current.disclosure.onOpen()
      }
    }).catch((e)=>{
      console.warn(e)

      var msg =e;
      if (e.response !==undefined && e.response.data !==undefined && e.response.data.msg !==undefined){
        msg =e.response.data.msg
      }

      msgDlgState[2].current.title ='Error'
      
      msgDlgState[2].current.context =msg
      msgDlgState[2].current.showCancelBtn =false
      msgDlgState[2].current.onConfirm =()=>{
        msgDlgState[2].current.disclosure.onClose()
      }

      msgDlgState[2].current.disclosure.onOpen()
    }).finally(()=>{
      processingTable1Request[1](false)
    })
  }

  var check_kill_rank =(tmp_cookie)=>{
    if (processingTable2Request[2].current ===true || processingLogin[2].current ===true){
      return
    }

    tableData[1]([])
    currPageIdx[1](0)
    processingTable2Request[1](true)
    axios.get('https://1gg0c40d3e.execute-api.ap-northeast-1.amazonaws.com/Prod/dailyKillTop?token='+tmp_cookie.token, ).then((res)=>{
      if (res.status ===200 && res.data.status ==='success'){
        tableData[1](res.data.data)
      }else{
        var msg =res.status
        if (res.data !==undefined && res.data.msg !==undefined){
          msg =res.data.msg
        }

        msgDlgState[2].current.title ='Error'
        msgDlgState[2].current.context =msg
        msgDlgState[2].current.showCancelBtn =false
        msgDlgState[2].current.onConfirm =()=>{
          msgDlgState[2].current.disclosure.onClose()
        }

        msgDlgState[2].current.disclosure.onOpen()
      }
    }).catch((e)=>{
      console.warn(e)

      var msg =e;
      if (e.response !==undefined && e.response.data !==undefined && e.response.data.msg !==undefined){
        msg =e.response.data.msg
      }

      msgDlgState[2].current.title ='Error'
      
      msgDlgState[2].current.context =msg
      msgDlgState[2].current.showCancelBtn =false
      msgDlgState[2].current.onConfirm =()=>{
        msgDlgState[2].current.disclosure.onClose()
      }

      msgDlgState[2].current.disclosure.onOpen()
    }).finally(()=>{
      processingTable2Request[1](false)
    })
  }

  var check_role_data =(tmp_cookie)=>{
    if (processingRequest[2].current ===true || processingLogin[2].current ===true){
      return
    }

    roleData[1](undefined)
    processingRequest[1](true)
    axios.get('https://1gg0c40d3e.execute-api.ap-northeast-1.amazonaws.com/Prod/acnt?token='+tmp_cookie.token, ).then((res)=>{
      if (res.status ===200 && res.data.status ==='success'){
        //apply data
        //convert data
        var result ={
          selected_role: undefined,
          mid: tmp_cookie.mid,
          roles: []
        }
        var keys =Object.keys(res.data.data)
        for(var i=0;i<keys.length;++i){
          result.roles.push({
            id: keys[i],
            ...res.data.data[keys[i]]
          })
        }
        if (result.roles.length>0){
          result.selected_role =0
        }
        roleData[1](result)
        // console.warn(roleData[2].current)

      }else{
        var msg =res.status
        if (res.data !==undefined && res.data.msg !==undefined){
          msg =res.data.msg
        }

        msgDlgState[2].current.title ='Error'
        msgDlgState[2].current.context =msg
        msgDlgState[2].current.showCancelBtn =false
        msgDlgState[2].current.onConfirm =()=>{
          msgDlgState[2].current.disclosure.onClose()
        }

        msgDlgState[2].current.disclosure.onOpen()
      }
      

    }).catch((e)=>{
      console.warn(e)

      var msg =e;
      if (e.response !==undefined && e.response.data !==undefined && e.response.data.msg !==undefined){
        msg =e.response.data.msg
      }

      msgDlgState[2].current.title ='Error'
      
      msgDlgState[2].current.context =msg
      msgDlgState[2].current.showCancelBtn =false
      msgDlgState[2].current.onConfirm =()=>{
        msgDlgState[2].current.disclosure.onClose()
      }

      msgDlgState[2].current.disclosure.onOpen()
    }).finally(()=>{
      processingRequest[1](false)
    })

  }

  return(
    <SlideAnimatePage ref={refl}>
      <main className={style['bg']}>
        <div className={['column','items-center', style['frame']].join(" ")}>
          { 
            (processingRequest[0]||processingLogin[0])?(
              <div className={['col-auto', 'column', 'items-center', 'justify-center'].join(" ")} style={{width: isPortraitMode[0]?'100%':'unset', minHeight: '100px'}}>
                <Spinner/>
              </div>
            ):isLogin[0]?(
              <div className={['col-auto', 'column',].join(" ")} style={{width: isPortraitMode[0]?'100%':'unset',}}>
                {
                  isPortraitMode[0]?(
                    <>
                      <div className={['col-auto', 'row', 'no-wrap', 'items-center', 'justify-around'].join(' ')}>
                        <div className={['col-auto', 'row', 'items-center'].join(" ")}>
                          <div className={['col-auto', style['item-label']].join(' ')}>通行證</div>
                          <Menu>
                            <MenuButton className={['col-auto', 'row', 'items-center', style['dropdown-btn']].join(' ')}>
                              <label className={style['dropdown-btn-label']}>{roleData[0]!==undefined?roleData[0].mid:'---'}</label>
                            </MenuButton>
                            <Portal>
                              <MenuList>
                                <MenuItem key={1} onClick={()=>{
                                  processingLogin[1](true)
                                  // console.warn(processingLogin[2].current)

                                  setTimeout(()=>{
                                    const params = `popup,scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=480,height=640`;
                                    var login_url =host+'/sso?client-id='+cid+'&prompt-account=true&prompt-type=mid&sso-ref='+encodeURIComponent(window.location.href)
                                    console.warn('229 - open window with url : '+login_url)
                                    window.open(login_url, '', params)
                                  },0)

                                }}>{'切換通行證/帳號'}</MenuItem>
                              </MenuList>
                            </Portal>
                          </Menu>
                        </div>
                        <div className={['col-auto', 'row', 'items-center'].join(" ")}>
                          <div className={['col-auto', style['item-label']].join(' ')}>角色名稱</div>
                          <Menu>
                            <MenuButton className={['col-auto', 'row', 'items-center', style['dropdown-btn']].join(' ')}>
                              <label className={style['dropdown-btn-label']}>{(roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(roleData[0]['roles'][roleData[0]['selected_role']]['角色名稱']):'---'}</label>
                            </MenuButton>
                            <Portal>
                              <MenuList>
                              {
                                (roleData[0]!==undefined&&roleData[0]['roles'].length>0)?(                                  
                                  roleData[0]['roles'].map((item,idx)=>{
                                    return (
                                      <MenuItem key={item.id} onClick={()=>{
                                        roleData[1]({
                                          ...roleData[2].current,
                                          selected_role: idx,
                                        })
                                      }}>{item['角色名稱']}</MenuItem>
                                    )
                                  })
                                ):(
                                  <MenuItem key={0} onClick={()=>{}}>{'---'}</MenuItem>
                                )
                              }

                              </MenuList>
                            </Portal>
                          </Menu>
                          
                        </div>

                      </div>
                      <div className={['col-auto', 'row', 'items-center', style['row-stride-30']].join(" ")}/>
                      <div className={['col-auto', 'row', 'no-wrap', 'items-center', 'justify-around'].join(' ')}>
                        <div className={['col-auto', 'row', 'items-center'].join(" ")}>
                          <div className={['col-auto', style['item-label']].join(' ')}>陣營</div>
                          <div className={['col-auto', 'row', 'items-center', 'justify-center', style['text-box']].join(' ')}>{
                            (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                              roleData[0]['roles'][roleData[0]['selected_role']]['陣營']
                            ):('---')
                          }</div>

                        </div>
                        <div className={['col-auto', 'row', 'items-center'].join(" ")}>
                          <div className={['col-auto', style['item-label']].join(' ')}>職業</div>
                          <div className={['col-auto', 'row', 'items-center', 'justify-center', style['text-box']].join(' ')}>{
                            (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                              roleData[0]['roles'][roleData[0]['selected_role']]['職業']
                            ):('---')
                          }</div>

                        </div>
                      </div>
                      <div className={['col-auto', 'row', 'items-center', style['row-stride-30']].join(" ")}/>
                      <div className={['col-auto', 'row', 'no-wrap', 'items-center', 'justify-around'].join(' ')}>
                        <div className={['col-auto', 'row', 'items-center'].join(" ")} style={{width: '94%'}}>
                          <div className={['col-auto', style['item-label']].join(' ')}>總榜排名</div>
                          <div className={['col-auto', style['text-box-ext-1']].join(' ')}/>
                          <div className={['col', 'row', 'items-center', 'justify-center', style['text-box-ext-2']].join(' ')}>{
                            (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                              roleData[0]['roles'][roleData[0]['selected_role']]['總榜排名']
                            ):('---')
                          }</div>
                          <div className={['col-auto', style['text-box-ext-3']].join(' ')}/>
                        </div>

                      </div>
                      <div className={['col-auto', 'row', 'items-center', style['row-stride-30']].join(" ")}/>
                      <div className={['col-auto', 'row', 'no-wrap', 'items-center', 'justify-around'].join(' ')}>
                        <div className={['col-auto', 'row', 'items-center'].join(" ")}>
                          <div className={['col-auto', style['item-label']].join(' ')}>累積擊殺</div>
                          <div className={['col-auto', 'row', 'items-center', 'justify-center', style['text-box']].join(' ')}>{
                            (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                              roleData[0]['roles'][roleData[0]['selected_role']]['累積擊殺']
                            ):('---')
                          }</div>

                        </div>
                        <div className={['col-auto', 'row', 'items-center'].join(" ")}>
                          <div className={['col-auto', style['item-label']].join(' ')}>累積死亡</div>
                          <div className={['col-auto', 'row', 'items-center', 'justify-center', style['text-box']].join(' ')}>{
                            (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                              roleData[0]['roles'][roleData[0]['selected_role']]['累積死亡']
                            ):('---')
                          }</div>

                        </div>
                      </div>

                    </>
                  ):(
                    <>
                      <div className={['col-auto', 'row', 'items-center'].join(" ")}>
                        <div className={['col-auto', style['item-label']].join(' ')}>通行證</div>
                        <Menu>
                          <MenuButton className={['col-auto', 'row', 'items-center', style['dropdown-btn']].join(' ')}>
                            <label className={style['dropdown-btn-label']}>{(roleData[0]!==undefined)?roleData[0].mid:'---'}</label>
                            
                          </MenuButton>
                          <Portal>
                            <MenuList>
                              <MenuItem key={1} onClick={()=>{
                                processingLogin[1](true)
                                
                                setTimeout(()=>{
                                  const params = `popup,scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=480,height=640`;
                                  var login_url =host+'/sso?client-id='+cid+'&prompt-account=true&prompt-type=mid&sso-ref='+encodeURIComponent(window.location.href)
                                  console.warn('229 - open window with url : '+login_url)
                                  window.open(login_url, '', params)
                                },0)

                              }}>{'切換通行證/帳號'}</MenuItem>

                            </MenuList>
                          </Portal>
                        </Menu>
                      </div>
                      <div className={['col-auto', 'row', 'items-center', style['row-stride-30']].join(" ")}/>
                      <div className={['col-auto', 'row', 'items-center'].join(" ")}>
                        <div className={['col-auto', style['item-label']].join(' ')}>角色名稱</div>
                        <Menu>
                          <MenuButton className={['col-auto', 'row', 'items-center', style['dropdown-btn']].join(' ')}>
                            <label className={style['dropdown-btn-label']}>{(roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?roleData[0]['roles'][roleData[0]['selected_role']]['角色名稱']:'---'}</label>
                          </MenuButton>
                          <Portal>
                            <MenuList>
                              {
                                (roleData[0]!==undefined&&roleData[0]['roles'].length>0)?(                                  
                                  roleData[0]['roles'].map((item,idx)=>{
                                    return (
                                      <MenuItem key={item.id} onClick={()=>{
                                        roleData[1]({
                                          ...roleData[2].current,
                                          selected_role: idx,
                                        })
                                      }}>{item['角色名稱']}</MenuItem>
                                    )
                                  })
                                ):(
                                  <MenuItem key={0} onClick={()=>{}}>{'---'}</MenuItem>
                                )
                              }

                            </MenuList>
                          </Portal>
                        </Menu>

                        <div className={['col-auto', style['item-label-2']].join(' ')}>陣營</div>
                        <div className={['col-auto', 'row', 'items-center', 'justify-center', style['text-box']].join(' ')}>{
                          (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                            roleData[0]['roles'][roleData[0]['selected_role']]['陣營']
                          ):('---')
                        }</div>

                        <div className={['col-auto', style['item-label-3']].join(' ')}>職業</div>
                        <div className={['col-auto', 'row', 'items-center', 'justify-center', style['text-box']].join(' ')}>{
                          (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                            roleData[0]['roles'][roleData[0]['selected_role']]['職業']
                          ):('---')
                        }</div>
                      </div>
                      <div className={['col-auto', 'row', 'items-center', style['row-stride-30']].join(" ")}/>
                      <div className={['col-auto', 'row', 'items-center'].join(" ")}>
                        <div className={['col-auto', style['item-label']].join(' ')}>總榜排名</div>
                        <div className={['col-auto', 'row', 'items-center', 'justify-center', style['text-box']].join(' ')}>{
                          (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                            roleData[0]['roles'][roleData[0]['selected_role']]['總榜排名']
                          ):('---')
                        }</div>

                        <div className={['col-auto', style['item-label-3']].join(' ')}>累積擊殺</div>
                        <div className={['col-auto', 'row', 'items-center', 'justify-center', style['text-box']].join(' ')}>{
                          (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                            roleData[0]['roles'][roleData[0]['selected_role']]['累積擊殺']
                          ):('---')
                        }</div>

                        <div className={['col-auto', style['item-label-3']].join(' ')}>累積死亡</div>
                        <div className={['col-auto', 'row', 'items-center', 'justify-center', style['text-box']].join(' ')}>{
                          (roleData[0]!==undefined&&roleData[0]['roles'].length>roleData[0]['selected_role'])?(
                            roleData[0]['roles'][roleData[0]['selected_role']]['累積死亡']
                          ):('---')
                        }</div>
                      </div>
                    
                    </>
                  )
                }

                <div className={['col-auto', 'row', 'items-center', style['row-stride-30']].join(" ")}/>
                <div className={['col-auto', style['sep-line']].join(' ')}/>
                <div className={['col-auto', 'row', 'items-center', style['row-stride-30']].join(" ")}/>
                <div className={['col-auto', 'row', 'items-center', 'justify-center'].join(' ')}>
                  <button 
                    onClick={()=>{
                      var tmp_cookie =cookies['94hitoken-shaiya-achievement-1']
                      if (isCookiesValid(tmp_cookie)){
                        check_total_rank(tmp_cookie)
                      }
                    }}
                    className={['col-auto', style['button']].join(' ')}>{
                      processingTable1Request[0]?(<Spinner/>):(
                        <label className={style['shiny-string']} data="戰功總榜">戰功總榜</label>
                      )
                    }</button>
                  <button 
                    onClick={()=>{
                      var tmp_cookie =cookies['94hitoken-shaiya-achievement-1']
                      if (isCookiesValid(tmp_cookie)){
                        check_kill_rank(tmp_cookie)
                      }
                    }}
                    className={['col-auto', style['button']].join(' ')}>{
                    processingTable2Request[0]?(<Spinner/>):(
                        <label className={style['shiny-string']} data="每日擊殺榜">每日擊殺榜</label>
                      )
                    }</button>
                </div>
                <div className={['col-auto', 'row', 'items-center', style['row-stride-30']].join(" ")}/>
                <div className={['col-auto']} style={{marginLeft: isPortraitMode[0]?'2%':'0'}}>戰功總榜 : 角色累計的戰功數,每天23:59更新</div>
                <div className={['col-auto']} style={{marginLeft: isPortraitMode[0]?'2%':'0'}}>每日擊殺 : 當日戰功獲取數量排行,每天23:59更新</div>

                {
                  tableData[0]===undefined?<></>:(
                    <>
                      <table className={['col-auto', style['table-font']].join(' ')}>
                        <thead className={style['table-header-bg']}>
                          <tr>
                            <th style={{position: 'relative', minWidth: '35px'}}><label className={style['table-shiny-string']} data="排名">排名</label></th>
                            <th style={{position: 'relative', minWidth: '40px'}}><label className={style['table-shiny-string']} data="擊殺數">擊殺數</label></th>
                            <th style={{position: 'relative', minWidth: '100px'}}><label className={style['table-shiny-string']} data="角色名稱">角色名稱</label></th>
                            <th style={{position: 'relative', minWidth: '35px'}}><label className={style['table-shiny-string']} data="等級">等級</label></th>
                            <th style={{position: 'relative', minWidth: '60px'}}><label className={style['table-shiny-string']} data="陣營">陣營</label></th>
                            <th style={{position: 'relative', minWidth: '50px'}}><label className={style['table-shiny-string']} data="職業">職業</label></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            tableData[0].length>0?(
                              tableData[0].slice(currPageIdx[0]*20, (currPageIdx[0]+1)*20).map((item, idx)=>{
                                return (
                                  <tr key={idx}>
                                    <td>
                                      {item['排名']}
                                    </td>
                                    <td>
                                      {item['擊殺數']}
                                    </td>
                                    <td>
                                      {item['角色名']}
                                    </td>
                                    <td>
                                      {item['等級']}
                                    </td>
                                    <td>
                                      {item['陣營']}
                                    </td>
                                    <td>
                                      {item['職業']}
                                    </td>
                                  </tr>
                                )
                              })
                            ):(
                              <>
                                <tr>
                                  <td colSpan="6">
                                    無資料
                                  </td>
                                </tr>
                              </>
                            )
                          }
                          
                        </tbody>
                      </table>
                      <div className={['col-auto', 'row', 'items-center', style['row-stride-30']].join(" ")}/>
                      <div className={['col-auto', 'row', 'items-center', 'justify-center', style['pagination-container']].join(' ')}>
                        <button className={['col-auto', 'row', 'itmes-center', 'justify-center', style['prev-btn']].join(' ')}
                          onClick={()=>{
                            var currpage =currPageIdx[2].current
                            if (currpage <=0){
                              return
                            }

                            currPageIdx[1](currpage-1)
                          }}
                        >上一頁</button>
                        {
                          [...Array( Math.ceil(tableData[0].length/20) )].map((_,idx)=>{
                            return (
                              <button className={['col-auto', 'row', 'itmes-center', 'justify-center', style['prev-btn-2'], style[(currPageIdx[0]===idx)?'active':'']].join(' ')}
                                onClick={()=>{
                                  currPageIdx[1](idx)
                                }}>
                                <div className={['row', 'items-center', 'justify-center', style['active-page']].join(' ')}>
                                  <label>{idx+1}</label>
                                </div>
                              </button>
                            )
                          })
                        }

                        <button className={['col-auto', 'row', 'itmes-center', 'justify-center', style['prev-btn']].join(' ')}
                          onClick={()=>{
                            var currpage =currPageIdx[2].current
                            if (currpage >=(Math.ceil(tableData[0].length/20)-1)){
                              return
                            }

                            currPageIdx[1](currpage+1)
                          }}
                        >下一頁</button>
                      </div>
                    </>
                  )
                }

              </div>
            ):(                
              <div className={['col', 'column', 'items-center', 'justify-center'].join(' ')}>
                <button 
                  onClick={()=>{
                    //check login status
                    var tmp_cookie =cookies['94hitoken-shaiya-achievement-1']

                    //require login action
                    if (isCookiesValid(tmp_cookie)===false){
                      processingLogin[1](true)
                      // console.warn(processingLogin[2].current)
                      
                      setTimeout(()=>{
                        const params = `popup,scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=480,height=640`;
                        var login_url =host+'/sso?client-id='+cid+'&prompt-account=true&prompt-type=mid&sso-ref='+encodeURIComponent(window.location.href)
                        console.warn('229 - open window with url : '+login_url)
                        window.open(login_url, '', params)
                      },0)
                      
                    }else{
                      // //logout
                      // //...
                      // removeCookie('94hitoken-shaiya-event-1', {path: '/',})
                      // check_login_state('')
                      // console.warn('238 - remove cookies')
                    }
                  }}
                  className={['col-auto', style['button']].join(' ')}><label className={style['shiny-string']} data="登入 94hi">登入 94hi</label></button>
              </div>
            )
          }
        </div>
        <div className={style['title']}/>
        <div className={style['game-logo']}/>

        {
          isPortraitMode[0]?(
            <>
              <div className={['row', 'items-center', 'no-wrap', style['drawer-copyright-container']].join(' ')}>
                <div className={['col'].join(' ')}></div>
                <div className={['col-auto'].join(' ')}>
                  <div className={['col-auto', 'row', 'items-center', 'justify-center'].join(' ')}>
                    <div className={['col-auto', style['logo94hi']].join(' ')}/>
                    <div className={['col-auto', style['logotomato']].join(' ')}/>
                    <div className={['col-auto', style['eyx']].join(' ')}/>
                    <div className={['col-auto', style['nexon']].join(' ')}/>
                  </div>
                  <div className={['col-auto', 'row', 'items-center', 'justify-between', style['drawer-copyright-string']].join(' ')} style={{width: '100%'}}>
                    <div className={['col-auto'].join(' ')}>COPYRIGHT©FUNMORE TECHNOLOGY All Right Reserved.</div>
                    <div className={['col-auto', style['ratiing']].join(' ')}/>
                  </div>
                </div>
                <div className={['col'].join(' ')}></div>
              </div>
            </>
          ):(
            <footer className={style['footer-container']}>
              <div className={['row', 'items-center', 'justify-center', style['logo-container']].join(' ')}>
                <div className={['col-auto', style['logo94hi']].join(' ')}/>
                <div className={['col-auto', style['logotomato']].join(' ')}/>
                <div className={['col-auto', style['eyx']].join(' ')}/>
                <div className={['col-auto', style['nexon']].join(' ')}/>
              </div>
              <div className={['column', 'items-end', 'justify-center', 'no-wrap', style['copyright-container']].join(' ')}>
                <div className={['col-auto', style['ratiing']].join(' ')}/>
                <div className={['col-auto', style['copyright']].join(' ')}>COPYRIGHT©FUNMORE TECHNOLOGY All Right Reserved.</div>
              </div>
            </footer>
          )
        }

      </main>
    </SlideAnimatePage>
  )
}
export default Intro